var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"mx-auto mb-12",attrs:{"dark":"","outlined":"","eager":"","min-height":"200"}},[_c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',{attrs:{"cols":"12","md":"9"}},[_vm._t("default")],2),_c('v-col',{attrs:{"cols":"12","md":"3"}},[_vm._t("options")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }